// An API response that was not 2xx. Carries the status so the shared query
// client can tell an expired session (401, renewed and retried) from any other
// failure (see isAuthError in src/queryClient.js).
export class HttpError extends Error {
  constructor(message, status) {
    super(message);
    this.name = "HttpError";
    this.status = status;
  }
}

// Parses a JSON response, or throws an HttpError for a non-2xx one. Resolving
// an error body instead would hand callers, and React Query's cache, an
// `{ error }` object in place of the data they asked for.
export async function readJsonOrThrow(response, description) {
  if (!response.ok) {
    throw new HttpError(
      `${description} failed: ${response.status}`,
      response.status,
    );
  }
  return response.json();
}
